import styled from "styled-components";
import { 
    Menu,
    MenuButton,
    MenuList,
    MenuItem, 
  } from '@chakra-ui/react'
import { TriangleDownIcon } from '@chakra-ui/icons'


type Props = { 
    title: string;
    items: string[];
  }

export default function SMenuFilter(props: Props) {
    return (
        <Menu>
            <MenuButton fontSize={18} fontFamily='KFAGothic' width='100%'>
                <MenuText>{props.title}</MenuText><TriangleDownIcon fontSize={12} />
            </MenuButton>
            <MenuList 
                style={{ 
                    boxShadow:'0px 4px 20px 0px rgba(0, 0, 0, 0.10)', 
                    minWidth:'97px', 
                    marginLeft:'25%',
                }} 
            >
                {props.items.map((a,i)=>{
                    return <MenuItem key={a} height='41px' justifyContent='center'><MenuText>{a}</MenuText></MenuItem>
                })}
            </MenuList>
        </Menu>
      );
}
 
const MenuText = styled.span`
font-family: 'KFAGothic' !important;
font-size: 18px;
margin-right: 5px;
`